import TimerComponent from "../timer";
import "../../css/inner-page/sectionHero.scss";
import Lottie from "react-lottie";
import * as animationData from "../../assets/homeBackgroundLottie.json";
import { ReactComponent as Star } from "../imgComponents/menu-star.svg";

export default function Section(props) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <section id="hero-section-inner">
      <div className="hero-background">
        <Lottie options={defaultOptions} />
      </div>
      <div className="hero-section-content">
        <div className="pre-title-wrapper">
          <Star />
          <span className="pre-title">{props.pre_tiltle}</span>
        </div>
        <h1 dangerouslySetInnerHTML={{ __html: props.hero_title }} />
        <p className="font-regular">{props.content ? props.content : props.hero_paragraph}</p>
      </div>
      <TimerComponent {...props.timer} />
    </section>
  );
}
